// extracted by mini-css-extract-plugin
export default {"header":"stripe-elements-popup_header__OJKrC","close":"stripe-elements-popup_close__+ndXK"};